import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const linkStyles = tv({
    slots: {
        base: `
      iris:inline-flex
      iris:w-max
      iris:items-baseline
      iris:justify-center
      iris:gap-(--comp-space-gap-link-icon)
      iris:tracking-(--comp-type-tracking-link)
      iris:text-(--comp-color-content-link-rest)
      iris:duration-(--comp-motion-duration-link)
      iris:ease-(--comp-motion-easing-link)
      iris:hover:text-(--comp-color-content-link-hover)
      iris:focus-visible:rounded-xs
      iris:active:text-(--comp-color-content-link-pressed)
    `,
        baseFont: "iris:font-(family-name:--comp-type-font-link)",
        icon: "",
    },
    variants: {
        variant: {
            inline: {
                base: "iris:underline",
            },
            standalone: {
                base: `
          iris:flex
          iris:min-h-(--comp-size-height-link)
          iris:no-underline
          iris:hover:underline
          iris:active:underline
        `,
            },
        },
        inverse: {
            false: {
                base: focusStyles.default,
            },
            true: {
                base: `
          iris:text-(--comp-color-content-link-inverse-rest)
          iris:hover:text-(--comp-color-content-link-inverse-hover)
          iris:active:text-(--comp-color-content-link-inverse-pressed)
          ${focusStyles.inverse}
        `,
            },
        },
        weight: {
            regular: {
                base: "iris:font-(--comp-type-weight-link-regular)!",
            },
            bold: {
                base: "iris:font-(--comp-type-weight-link-bold)!",
            },
        },
        size: {
            md: {
                base: "iris:text-(length:--comp-type-size-link-md)",
                icon: "iris:w-(--comp-size-icon-link-md)",
            },
            sm: {
                base: "iris:text-(length:--comp-type-size-link-sm)",
                icon: "iris:w-(--comp-size-icon-link-sm)",
            },
            xs: {
                base: `iris:text-(length:--comp-type-size-link-xs)`,
                icon: `iris:w-(--comp-size-icon-link-xs)`,
            },
            xxs: {
                base: `iris:text-(length:--comp-type-size-link-xxs)`,
                icon: `iris:w-(--comp-size-icon-link-xxs)`,
            },
        },
        iconPosition: {
            left: {
                base: `iris:flex-row`,
            },
            right: {
                base: `iris:flex-row-reverse`,
            },
        },
        iconSize: {
            md: {
                icon: `
          iris:h-(--comp-size-icon-link-sm)
          iris:w-(--comp-size-icon-link-sm)
        `,
            },
            lg: {
                icon: `
          iris:h-(--comp-size-icon-link-lg)
          iris:w-(--comp-size-icon-link-lg)
        `,
            },
        },
    },
    compoundVariants: [
        {
            size: "md",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-sm)
          iris:w-(--comp-size-icon-link-sm)
        `,
            },
        },
        {
            size: "md",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-lg)
          iris:w-(--comp-size-icon-link-lg)
        `,
            },
        },
        {
            size: "sm",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-sm)
          iris:w-(--comp-size-icon-link-sm)
        `,
            },
        },
        {
            size: "sm",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-lg)
          iris:w-(--comp-size-icon-link-lg)
        `,
            },
        },
        {
            size: "xs",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-xs)
          iris:w-(--comp-size-icon-link-xs)
        `,
            },
        },
        {
            size: "xs",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-md)
          iris:w-(--comp-size-icon-link-md)
        `,
            },
        },
        {
            size: "xxs",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-xxs)
          iris:w-(--comp-size-icon-link-xxs)
        `,
            },
        },
        {
            size: "xxs",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-xs)
          iris:w-(--comp-size-icon-link-xs)
        `,
            },
        },
    ],
    defaultVariants: {
        variant: "inline",
        size: "md",
        weight: "regular",
        iconPosition: "left",
    },
});

export { linkStyles as default };
